// extracted by mini-css-extract-plugin
export default {"container":"InfoButtonDocumentation_container__d41JQ","propertyDivider":"InfoButtonDocumentation_propertyDivider__H25AJ","warning":"InfoButtonDocumentation_warning__KeEa3"};